import { render, staticRenderFns } from "./WxWorkOrderList.vue?vue&type=template&id=1ec5dcb3&scoped=true"
import script from "./WxWorkOrderList.vue?vue&type=script&lang=js"
export * from "./WxWorkOrderList.vue?vue&type=script&lang=js"
import style0 from "./WxWorkOrderList.vue?vue&type=style&index=0&id=1ec5dcb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec5dcb3",
  null
  
)

export default component.exports